import * as React from "react";

function SvgLivechat(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 296 295"
      fill="none"
      {...{ ...props, ref }}
    >
      <path
        d="M293.535 183.379a69.62 69.62 0 01-70.21 63.683h-38.718L110.857 295v-47.938l73.75-47.937h38.792a21.685 21.685 0 0022.346-19.396 837.192 837.192 0 00-.553-110.625 20.537 20.537 0 00-19.322-18.659c-25.149-1.549-51.625-2.508-78.138-2.508-26.513 0-52.99.886-78.138 2.656A20.54 20.54 0 0050.27 69.25a837.356 837.356 0 00-.553 110.625 21.68 21.68 0 0022.346 19.249h38.793v47.937h-38.72a69.618 69.618 0 01-70.062-63.72 885.731 885.731 0 01.554-118 68.551 68.551 0 0163.535-62.54C92.42.923 120.075 0 147.732 0c27.656 0 55.312.922 81.567 2.803a68.553 68.553 0 0163.683 62.687 885.584 885.584 0 01.553 117.889z"
        fill="#FF5100"
      />
    </svg>
  );
}

export default React.forwardRef(SvgLivechat);
